module.exports = __webpack_public_path__ + "static/img/0.278d199.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-edge/0.png
// module id = zVaa
// module chunks = 12